import { render } from "./UserDetails.vue?vue&type=template&id=44807b7b&scoped=true&ts=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=44807b7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44807b7b"]])

export default __exports__